import React, { useEffect, useState } from 'react'
import { isString, first } from 'lodash'
import withStore from 'hoc/withStore'

import { fetchDataFromDocument } from 'pages/Scenario/actions'
import { getQueryString } from '../helpers/input-element'

const withDefault = (WrappedComponent) => {
  const wrappedDocument = ({
    option,
    filterBy,
    instances,
    formValues,
    documentType,
    defaultField,
    optionKey = 'title',
    filterKey = 'value',
    minField,
    maxField,
    wizard,
    value,
    setValue,
    ...props
  }) => {
    const { formData, creationMode, clone, instanceId } = wizard

    const [defaultValue, setDefaultValue] = useState()
    const [prevQueryString, setPrevQueryString] = useState(null)

    const { disabled } = props

    useEffect(() => {
      if (
        !disabled &&
        isString(documentType) &&
        isString(optionKey) &&
        isString(defaultField)
      ) {
        const queryValues = { type: documentType, [optionKey]: defaultField }
        const queryString = getQueryString(queryValues)

        // If there is a filterBy condition and the string is not changed, it doesn't perform a new fetch
        if (filterBy && (!queryString || queryString === prevQueryString))
          return

        fetchDataFromDocument({
          instanceId,
          params: queryString
        })
          .then((result) => {
            setDefaultValue(first(result.body)[filterKey])
            setPrevQueryString(queryString)
          })

          .catch((error) => console.log(error))
      }
    }, [disabled, documentType, defaultField, optionKey, filterKey])

    return (
      <WrappedComponent
        {...props}
        formData={formData}
        creationMode={creationMode}
        clone={clone}
        defaultValue={defaultValue}
        value={value}
        setValue={setValue}
      />
    )
  }

  return withStore(React.memo(wrappedDocument), ['wizard', 'instances'])
}

export default withDefault
